<template>
<span>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon @click.native="dialog = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Send Message</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click.native="sendMessage">Send</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container>
        <v-text-field
          name="input-1-3"
          label="To"
          v-model="reciever"
          single-line
        ></v-text-field>

        <v-text-field
          name="input-1-3"
          label="Subject"
          v-model="subject"
          single-line
        ></v-text-field>

    
                <quill-editor class="editor-example bubble"
                      ref="myTextEditor"
                      v-model="message"
                      :options="editorOption"
                      >
                </quill-editor>

        </v-container>

      </v-card>
    </v-dialog>
  </v-layout>
  </span>
</template>

<script>
import axios from "axios";
import { quillEditor } from "vue-quill-editor";
export default {
    components:{
           quillEditor
    },
  data() {
    return {
      dialog: false,
      reciever: "",
      subject: "",
      message: "",
      editorOption: {
        theme: "bubble",
        placeholder: "Send a new Message",
        modules: {
          toolbar: [
            ["bold", "italic"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["clean"]
          ]
        }
      }
    };
  },
  methods: {
    getUserId() {
        return this.users.find((user)=> {return user.email == this.reciever})._id
    },
    sendMessage() {
        if(this.getUserId(this.reciever) == null)
        {
            alert(null);
            return
        }
      axios
        .post("/api/messages", {
          message: this.message,
          sender: this.user._id,
          reciever: this.getUserId(this.reciever)
        })
        .then(response => {
          this.$emit("newMessage");
          this.newMessage = "";
        });
    }
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    users() {
        return this.$store.getters.loadUsers;
    }
  }
};
</script>


<style>
.ql-container {
font-family: 'Roboto', sans-serif !important;
}
</style>


<style lang="scss" scoped>

.quill-editor,
.quill-code {
  height: 10rem;
  margin-top: 5rem;
  font-family: 'Roboto', sans-serif;
}
.quill-editor {
  border-bottom: none;
   padding: 1rem;
   font-family: 'Roboto', sans-serif;
}
.quill-code {
  border: none;
  height: auto;
  > code {
    font-family: 'Roboto', sans-serif;
    width: 70%;
    margin: 10px;
    padding: 1rem;
    border: 1px solid #ccc;
    border-radius: 0;
    height: 10rem;
    overflow-y: auto;
    z-index: 999999;
  }
}
</style>

<style src='@/../static/quill.bubble.css'>


// WEBPACK FOOTER //
// src/components/Partials/NewMessage.vue